import React from 'react'

const news1 = () => {
  return (
    <>
            <div className="audit-page">
          <section className="audit-cover">
             <div className="container">
                <div className="audit-cover-para">
                  <h1 style={{color: "#f1f1f1", fontSize: "42px"}}>Latest amendment in Direct taxes</h1>
                </div>
             </div>
          </section>
          <section className="audit-page-content container" style={{marginBottom: "40px"}}>
             <h5><strong>Section 115BBH of the Bill deals with tax on virtual digital assets.</strong></h5>
             

             <div className="serv">
               <div className='inclu1'>
                  <p>Clause (2)(b) prevents loss on the trading of crypto assets from being set off against income under "any other provision of the IT act.</p>
                  <p>As per the amendment, the word "other" is dropped. Under the amended law, loss from crypto assets cannot be set off against gains in crypto assets as well.</p>
                  <p>"The proposed 30 percent tax irrespective of whether crypto-assets are capital assets or not will be detrimental to the investor growth that the industry has been seeing so far ..</p>
                  
               </div>
               
             </div>
          </section>
      </div> 
    </>
  )
}

export default news1
